import { createContext, useContext, useState } from "react";
import { allTasks } from "../components/MyTask/data";

const TaskContext = createContext();

export function TaskProvider({ children }) {
  const [myTasks, setMyTasks] = useState(allTasks);

  const addMyTask = (task) =>
    setMyTasks(prev => [task, ...prev]);

  const updateTask = (id, changes) =>
    setMyTasks(prev => prev.map(t => t.id === id ? { ...t, ...changes } : t));

  return (
    <TaskContext.Provider value={{ myTasks, addMyTask, updateTask }}>
      {children}
    </TaskContext.Provider>
  );
}

export const useTaskContext = () => useContext(TaskContext);
export const useTasks = () => useContext(TaskContext);
